// extracted by mini-css-extract-plugin
export default {"imageContainer":"user-details_imageContainer__hkYRv","userDetailsContainer":"user-details_userDetailsContainer__tQs+s","button":"user-details_button__RefZ6"};